<div class="main-wrapper">
  <div class="container">
    <div class="heading text-center">{{section?.header}}</div>
    <div class="divider d-lg-block d-md-block d-none"></div>
    <mat-accordion>
      <div class="row faqs">
        <div class="col-12 col-lg-6 col-md-6 faqs-section" *ngFor="let item of section?.faqs1; first as isFirst">
          <mat-expansion-panel #panel1 hideToggle [expanded]="isFirst">
            <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
              <mat-panel-title>
                  <mat-icon class="arrows">{{panel1.expanded  ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon> {{item.title}}
                  {{item?.question}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>{{item?.answer}}</p>
            <app-sac-button label="Start a Fundraiser" width="280px" height="35px" [redirectSac]="true"></app-sac-button>
          </mat-expansion-panel>
        </div>
        <div class="col-12 col-lg-6 col-md-6 faqs-section" *ngFor="let item of section?.faqs2">
          <mat-expansion-panel #panel1 hideToggle>
            <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
              <mat-panel-title>
                <mat-icon class="arrows">{{panel1.expanded  ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon> {{item.title}}
                {{item?.question}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <p>{{item?.answer}}</p>
            <app-sac-button label="Start a Fundraiser" width="280px" height="35px" [redirectSac]="true"></app-sac-button>
          </mat-expansion-panel>
        </div>
      </div>
    </mat-accordion>
  </div>
</div>